/**
 * @copyright Copyright 2019 Epic Systems Corporation
 * @file getNumStarted selector
 * @author Roland Scott
 * @module react-async-hook\internal\state\selectors\get-num-started
 */

import { IAsyncState } from "../types";

/**
 * Get the number of async operations that have been started since we began tracking.
 * @param state The async state
 */
export function getNumStarted(state: IAsyncState): number {
	if (!state) {
		throw new Error("State not defined.");
	}
	const { ids } = state;
	if (!ids) {
		return 0;
	}
	return ids.length;
}
